export const buildRegistrationParams = (contactFormResult, stateAbbreviation) => {
  const regParams = new URLSearchParams({
    apartment: contactFormResult?.unit_number,
    city: contactFormResult?.city,
    date_of_birth_day: parseInt(contactFormResult?.date_of_birth.split('-')[2]),
    date_of_birth_month: parseInt(contactFormResult?.date_of_birth.split('-')[1]),
    date_of_birth_year: parseInt(contactFormResult?.date_of_birth.split('-')[0]),
    email: contactFormResult?.email,
    first_name: contactFormResult?.first_name,
    last_name: contactFormResult?.last_name,
    phone_number: contactFormResult?.phone.replace('+1', ''),
    state: stateAbbreviation,
    street_address: contactFormResult?.address,
    'tv-r': 'impactive',
    zip_5: contactFormResult?.zip_code,
  });

  return regParams;
};
